export const SIDEBAR_ONBOARDING_THREAD_ID = 'sidebar-onboarding-thread';

const buildSidebarOnboardingThreadItem = () => {
  return {
    id: SIDEBAR_ONBOARDING_THREAD_ID,
    label: 'Getting started with Pieve',
    age: null,
    inProgress: false,
    awaitingApproval: false,
    pinned: false,
    threadType: 'onboarding',
    automationActive: false,
    delta: null,
    childThreadItems: []
  };
};

export default buildSidebarOnboardingThreadItem;
